import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";

const PRIORITY_ZONES = [
  { name: "Le Havre", slug: "le-havre" },
  { name: "Montivilliers", slug: "montivilliers" },
  { name: "Harfleur", slug: "harfleur" },
  { name: "Gonfreville-l'Orcher", slug: "gonfreville-l-orcher" },
  { name: "Sainte-Adresse", slug: "sainte-adresse" },
  { name: "Octeville-sur-Mer", slug: "octeville-sur-mer" },
  { name: "Fécamp", slug: "fecamp" },
  { name: "Bolbec", slug: "bolbec" },
  { name: "Lillebonne", slug: "lillebonne" },
  { name: "Yvetot", slug: "yvetot" },
  { name: "Rouen", slug: "rouen" },
  { name: "Dieppe", slug: "dieppe" },
  { name: "Caen", slug: "caen" },
  { name: "Évreux", slug: "evreux" },
  { name: "Honfleur", slug: "honfleur" },
  { name: "Deauville", slug: "deauville" },
  { name: "Lisieux", slug: "lisieux" },
  { name: "Paris", slug: "paris" },
];

export default function ZonesSection() {
  return (
    <section id="zones" data-testid="zones-section" className="py-14 md:py-20 px-4 md:px-8 max-w-7xl mx-auto">
      <div className="mb-10 max-w-2xl">
        <span className="text-xs uppercase tracking-[0.2em] font-bold text-orange">Zones d'intervention</span>
        <h2 className="font-heading font-bold text-3xl md:text-4xl tracking-tight text-navy mt-3 mb-3">
          Basé au Havre, intervention en Normandie et partout en France
        </h2>
        <p className="text-muted-foreground text-sm md:text-base leading-relaxed">
          Express Delivery intervient au Havre et dans son agglomération, dans toute la Normandie et organise des transports vers les autres régions françaises.
        </p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-2.5">
        {PRIORITY_ZONES.map((city, i) => (
          <Link
            key={city.slug}
            to={`/transport-${city.slug}`}
            data-testid={`zone-city-${i}`}
            className="flex items-center gap-2 bg-white border border-gray-200 rounded-xl px-3.5 py-2.5 hover:border-orange transition-colors group"
          >
            <MapPin className="w-3.5 h-3.5 text-orange shrink-0" />
            <span className="text-navy group-hover:text-orange text-sm font-medium transition-colors truncate">{city.name}</span>
          </Link>
        ))}
      </div>

      <Link
        to="/transport-normandie"
        data-testid="zones-see-all-link"
        className="inline-flex items-center gap-2 mt-7 text-sm font-semibold text-navy hover:text-orange transition-colors"
      >
        Voir toute notre zone en Normandie <ArrowRight className="w-4 h-4" />
      </Link>
    </section>
  );
}
